var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"btn btn-primary btn-lg",attrs:{"href":_vm.embedderScript}},[_vm._v(" just bookmark it! ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }